export enum SeoTexts {
  title = 'MyBio.de - MyBio ist dein Bio',
  description = 'Lass die real Bio Lebensmittel nach Hause liefern',
}
